import { Component, Input, OnInit } from '@angular/core';
import { FaqSectionModel } from '@fgb/core';

@Component({
  selector: 'fgbcl-faq-section-card',
  templateUrl: './faq-section-card.component.html',
  styleUrls: ['./faq-section-card.component.scss'],
})
export class FaqSectionCardComponent implements OnInit {
  @Input() faqSection: FaqSectionModel;

  constructor() {}

  ngOnInit(): void {}
}
